const figmaFileIdRegexp = /(file|proto|design|board)\/([^/]+)/;

export const getFigmaFileId = (value: string) => {
  const fileSubstr = figmaFileIdRegexp.exec(value);
  return (fileSubstr && fileSubstr[2]) || null;
};
